import React, { Component } from "react";
import { AiFillSave } from "react-icons/ai";
import Guide from "../../MyFiles/ClotheSizeGuide.jpg";

class SizeClothe extends Component {
  constructor(props) {
    super(props);
    this.getRequest();
  }
  state = {
    userRequestJson: [],
    errorMessage: "",
    stepNo: 1,
    isHomePage: true,
  };
  componentDidMount() {
    this.getRequest();
  }
  getRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("CompetitionRequestTypeRef", 7);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-user-size-request`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ userRequestJson: myObject.data }, function () { });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  handleValue(event) {
    this.setState({ exchangeCode: event.target.value });
  }
  render() {
    const myRequest = this.state.userRequestJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <div className="mb-2">
          <span className="bg-dark text-white wp-text-small rounded p-1">
            تاریخ ثبت اطلاعات {e.RequestTime}
          </span>
        </div>
        <div className="title mb-2 text-dark">
          <strong>اطلاعات شما با موفقیت در سیستم ثبت شده است:</strong>
        </div>
        <div className="text-center">
          <span className={e.State_CSS}>
            <b>
              کفش: {this.props.userJson.ShoesSize} - پیراهن:{" "}
              {this.props.userJson.ShirtSize} - شلوار:{" "}
              {this.props.userJson.PanSize}
            </b>
            {this.props.userJson.isClotheSecondary === true ? (
              <>
                <p>
                  سایز کاپشن: {this.props.userJson.JacketSize} - لباس کار یکسره:{" "}
                  {this.props.userJson.WorksSize}
                </p>
              </>
            ) : null}
          </span>
        </div>
      </li>
    ));
    if (this.state.isHomePage === true) {
      return (
        <div className="w-100 body-padding">
          <React.Fragment>
            <p className="wp-header small">سایز البسته سازمانی</p>
            <ul className="Array p-0">
              {myRequest.length === 0 ? (
                <li className="Array-item">
                  <div className="item text-center">
                    <div className="alert alert-info te">
                      <p className="mb-0 text-center">
                        بعد از تکمیل کردن فرم امکان ویرایش آن وجود ندارد و
                        لباس‌های سازمانی شما بر اساس سایز اعلام شده تهیه و تحویل
                        می‌شود.
                      </p>
                    </div>
                    <p>
                      اینجانب <b>{this.props.userJson.full_name}</b> با کد
                      پرسنلی <b>{this.props.userJson.personeliCode}</b> سایز
                      لباس های سازمانی خود را به شرح ذیل اعلام می‌نمایم.
                    </p>
                    <div className="w-100"></div>
                    <div className="item text-right mb-2">
                      <label className="font-weight-bold">سایز پیراهن</label>
                      <select
                        id="ShirtSize"
                        name="ShirtSize"
                        type="text"
                        className="form-select form-select-lg text-center wp-input-text rounded-0"
                        placeholder="سایز پیراهن"
                        defaultValue=""
                      >
                        <option value="">انتخاب نمایید</option>
                        <option value="S">S</option>
                        <option value="M">M</option>
                        <option value="L">L</option>
                        <option value="XL">XL</option>
                        <option value="2XL">2XL</option>
                        <option value="3XL">3XL</option>
                        <option value="4XL">4XL</option>
                        <option value="5XL">5XL</option>
                        <option value="6XL">6XL</option>
                      </select>
                    </div>
                    <div className="item text-right mb-2">
                      <label className="font-weight-bold">سایز شلوار</label>
                      <select
                        id="PantsSize"
                        name="PantsSize"
                        type="text"
                        className="form-select form-select-lg text-center wp-input-text rounded-0"
                        placeholder="سایز شلوار"
                        defaultValue=""
                      >
                        <option value="">انتخاب نمایید</option>
                        <option value="40">40</option>
                        <option value="42">42</option>
                        <option value="44">44</option>
                        <option value="46">46</option>
                        <option value="48">48</option>
                        <option value="50">50</option>
                        <option value="52">52</option>
                        <option value="54">54</option>
                        <option value="56">56</option>
                        <option value="58">58</option>
                        <option value="60">60</option>
                      </select>
                    </div>
                    <div className="item text-right mb-2">
                      <label className="font-weight-bold">سایز کفش</label>
                      <select
                        id="ShoesSize"
                        name="ShoesSize"
                        type="text"
                        className="form-select form-select-lg text-center wp-input-text rounded-0"
                        placeholder="سایز کفش"
                        defaultValue=""
                      >
                        <option value="">انتخاب نمایید</option>
                        <option value="40">40</option>
                        <option value="41">41</option>
                        <option value="42">42</option>
                        <option value="43">43</option>
                        <option value="44">44</option>
                        <option value="45">45</option>
                        <option value="46">46</option>
                      </select>
                    </div>
                    {this.props.userJson.isClotheSecondary === true ? (
                      <>
                        <div className="item text-right mb-2">
                          <label className="font-weight-bold">سایز کاپشن</label>
                          <select
                            id="JacketSize"
                            name="JacketSize"
                            type="text"
                            className="form-select form-select-lg text-center wp-input-text rounded-0"
                            placeholder="سایز کاپشن"
                            defaultValue=""
                          >
                            <option value="">انتخاب نمایید</option>
                            <option value="M">M</option>
                            <option value="L">L</option>
                            <option value="XL">XL</option>
                            <option value="2XL">2XL</option>
                            <option value="3XL">3XL</option>
                            <option value="4XL">4XL</option>
                            <option value="5XL">5XL</option>
                            <option value="6XL">6XL</option>
                          </select>
                        </div>
                        <div className="item text-right mb-2">
                          <label className="font-weight-bold">
                            سایز لباس کار یکسره
                          </label>
                          <select
                            id="WorksSize"
                            name="WorksSize"
                            type="text"
                            className="form-select form-select-lg text-center wp-input-text rounded-0"
                            placeholder="سایز لباس کار یکسره"
                            defaultValue=""
                          >
                            <option value="">انتخاب نمایید</option>
                            <option value="M">M</option>
                            <option value="L">L</option>
                            <option value="XL">XL</option>
                            <option value="2XL">2XL</option>
                            <option value="3XL">3XL</option>
                            <option value="4XL">4XL</option>
                            <option value="5XL">5XL</option>
                            <option value="6XL">6XL</option>
                          </select>
                        </div>
                      </>
                    ) : null}
                    <div className="text-left mt-2">
                      <button
                        id="SubmitForm"
                        className="btn dina-btn-blue rounded-0"
                        onClick={this.submitForm}
                      >
                        <AiFillSave /> ثبت درخواست
                      </button>
                    </div>
                  </div>
                </li>
              ) : (
                myRequest
              )}
            </ul>
            <div className="col-12">
              <a href={Guide} rel="noopener noreferrer" className="wp-link" target="_blank">
                <img
                  className="img-banner"
                  src={Guide}
                  alt="نحوه اندازه گیری"
                ></img>
              </a>
            </div>
          </React.Fragment>
        </div>
      );
    }
  }
  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
      var ShirtSize = document.getElementById("ShirtSize").value;
      var PantsSize = document.getElementById("PantsSize").value;
      var ShoesSize = document.getElementById("ShoesSize").value;

      var JacketSizeEL = document.getElementById("JacketSize");
      var WorksSizeEL = document.getElementById("WorksSize");

      if (ShirtSize !== null && PantsSize !== null && ShoesSize !== null) {
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("RequestType", "ClotheSize");
        formdata.append("ShirtSize", ShirtSize);
        formdata.append("PantsSize", PantsSize);
        formdata.append("ShoesSize", ShoesSize);
        formdata.append(
          "JacketSize",
          JacketSizeEL === null ? 0 : JacketSizeEL.value,
        );
        formdata.append(
          "WorksSize",
          WorksSizeEL === null ? 0 : WorksSizeEL.value,
        );

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-user-clothe-request`,
          requestOptions,
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                errorMessage = "اطلاعات شما با موفقیت در سیستم ثبت شد.";
                this.props.getFullProfile();
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
                this.getRequest();
              } else {
                errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        errorMessage = "وارد کردن تمامی اطلاعات فرم ضروری می باشد.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default SizeClothe;
